import FormNewsletterUnsubscribe from '@/components/FormNewsletterUnsubscribe'
import vuewidget from './vuewidget'

export default function(dom, opts) {
  let options = {
    ...opts,
    vueComponent: FormNewsletterUnsubscribe,
    vueInit: null,
  }

  let page = vuewidget(dom, options)
  return page
}
